import {IPointer} from "../model/FormModel";


export const preparedPointer = (pointer: IPointer|string): IPointer =>
{
    pointer = typeof pointer === 'string' ? {fieldID: pointer} : pointer;
    if(pointer.itemID){
        return pointer;
    }

    pointer.index = pointer.index ?? null;
    pointer.childPointer = pointer.childPointer ?? null;

    let itemID = "id: " + pointer.fieldID;
    if(pointer.index !== null)
    {
        pointer.collectionType = "group_array";
        itemID += ", index: "+pointer.index;
    } else if(pointer.childPointer){
        pointer.collectionType = pointer.collectionType === "id_array" ? "id_array" : "group_object";
    } else {
        pointer.collectionType = "single";
    }
    if(pointer.childPointer){
        pointer.childPointer = preparedPointer(pointer.childPointer);
        itemID += " >> " + pointer.childPointer.itemID!;
    }
    pointer.itemID = itemID;
    return pointer;
}

export const getFinalChildPointer = (fromPointer: IPointer|string): IPointer =>
{
    fromPointer = preparedPointer(fromPointer);
    let nextPointer = fromPointer;
    while(nextPointer.childPointer){
        nextPointer = nextPointer.childPointer;
    }
    return nextPointer;
}

export const getParentPointer = (fromPointer: IPointer|string): IPointer|null =>
{
    fromPointer = preparedPointer(fromPointer);
    const determinePointer = (nextPointer:IPointer): IPointer|null => {
        if(!nextPointer.childPointer && ((nextPointer.index ?? null) === null)){
            return null;
        }
        const thisPointer:IPointer = {
            fieldID: nextPointer.fieldID,
            collectionType: nextPointer.collectionType,
        }
        if(!nextPointer.childPointer){
            return thisPointer;
        }
        thisPointer.index = nextPointer.index;
        if(!nextPointer.childPointer){
            return thisPointer;
        }
        const childPointer = determinePointer(nextPointer.childPointer)
        if(childPointer){
            thisPointer.childPointer = nextPointer.childPointer;
        }
        return thisPointer;
    }
    const parentPointer =  determinePointer(fromPointer);
    if(parentPointer){
        preparedPointer(parentPointer);
    }
    return parentPointer;
}

export const removeParentFromPointer = (fromPointer: IPointer, parentPointer: IPointer|string): IPointer|null =>
{
    fromPointer = preparedPointer(fromPointer);
    parentPointer = preparedPointer(parentPointer);
    const determinePointer = (nextPointer:IPointer, nextParentPointer:IPointer) => {
        if((nextPointer.fieldID !== nextParentPointer.fieldID) || ((nextPointer.index ?? null) !== (nextParentPointer.index ?? null)) || (nextPointer.collectionType !== nextParentPointer.collectionType)){
            return null;
        }
        if(!nextPointer.childPointer){
            return null;
        }
        if(!nextParentPointer.childPointer){
            return JSON.parse(JSON.stringify(nextPointer.childPointer))
        }
        return determinePointer(nextPointer.childPointer, nextParentPointer.childPointer);
    }
    const childPointer =  determinePointer(fromPointer, parentPointer);
    if(childPointer){
        preparedPointer(childPointer);
    }
    return childPointer;
}

export const createChildPointer = (withChildPointer: IPointer|string, ofParentPointer?: IPointer|string|null): IPointer =>
{
    withChildPointer = preparedPointer(withChildPointer);
    if(!ofParentPointer){
        return withChildPointer;
    }
    ofParentPointer = preparedPointer(ofParentPointer);
    const usePointer:IPointer = JSON.parse(JSON.stringify(ofParentPointer));
    const useChildPointer:IPointer = JSON.parse(JSON.stringify(withChildPointer));

    const addToPointer = (parentPointer:IPointer) => {
        parentPointer.itemID = undefined;
        if(!parentPointer.childPointer){
            parentPointer.childPointer = useChildPointer;
            return;
        }
        addToPointer(parentPointer.childPointer);
    }
    addToPointer(usePointer);
    preparedPointer(usePointer);

    return usePointer;
}

export const createChildIndexPointer = (index:number, ofParentPointer: IPointer|string): IPointer =>
{
    ofParentPointer = preparedPointer(ofParentPointer);
    const usePointer:IPointer = JSON.parse(JSON.stringify(ofParentPointer));
    const addToPointer = (parentPointer:IPointer) => {
        parentPointer.itemID = undefined;
        if(!parentPointer.childPointer){
            parentPointer.index = index;
            return;
        }
        addToPointer(parentPointer.childPointer);
    }
    addToPointer(usePointer);
    preparedPointer(usePointer);
    return usePointer;
}